module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/bella-1af3dc981458662479c1ea5569ccf278.svg";